import React, { useEffect, useRef, useState } from 'react';
interface MultipleSelectProps {
  divParentClassName?: string;
  inputClassName?: string;
  spanClassName?: string;
  indeterminate?: boolean;
  title?: string;
  name: string;
  type?: string; // header = có dropdown
  onSelectAll?: () => void;
  onSelectPage?: () => void;
  onDeselectAll?: () => void;
  onDeselectPage?: () => void;
  isAllSelected?: boolean;
  isPageSelected?: boolean;
}

export const MultipleSelectRef: React.ForwardRefRenderFunction<
  HTMLInputElement,
  MultipleSelectProps & React.InputHTMLAttributes<HTMLInputElement>
> = (
  {
    divParentClassName,
    inputClassName,
    spanClassName,
    title,
    indeterminate,
    type,
    onSelectAll,
    onSelectPage,
    onDeselectAll,
    onDeselectPage,
    isAllSelected = false,
    isPageSelected = false,
    ...props
  },
  forwardedRef,
) => {
  const innerRef = useRef<HTMLInputElement | null>(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (innerRef.current) {
      innerRef.current.indeterminate = !!indeterminate;
    }
  }, [indeterminate]);

  const showSelectAll = !isAllSelected;
  const showDeselectAll = isAllSelected || isPageSelected;
  const showSelectPage = !isAllSelected && !isPageSelected;
  const showDeselectPage = isAllSelected || isPageSelected;

  return (
    <div className={divParentClassName || 'flex relative items-center gap-x-[11px]'} onMouseLeave={() => setOpen(false)}>
      <input
        className={inputClassName || 'checkbox checkbox-primary rounded border-2 w-[18px] h-[18px]'}
        type="checkbox"
        {...props}
        ref={(instance: HTMLInputElement) => {
          innerRef.current = instance;
          if (typeof forwardedRef === 'function') {
            forwardedRef(instance);
          } else if (forwardedRef !== null) {
            forwardedRef.current = instance;
          }
        }}
      />
      {title && <span className={spanClassName || 'text-gray-500 leading-4 dark:text-gray-dark-500 text-[14px] max-w-[183px]'}>{title}</span>}

      {/* Nếu là header thì hiển thị dropdown */}
      {type === 'header' && (
        <div className="left-6 top-0 cursor-pointer" onMouseEnter={() => setOpen(true)}>
          <span className="px-1 py-0.5 text-gray-500">▼</span>

          {open && (
            <div className="absolute left-0 mt-1 bg-white border rounded shadow text-sm z-10">
              {showSelectAll && (
                <div className="px-3 py-1 hover:bg-gray-100 cursor-pointer" onClick={onSelectAll}>
                  Select All
                </div>
              )}
              {showSelectPage && (
                <div className="px-3 py-1 hover:bg-gray-100 cursor-pointer" onClick={onSelectPage}>
                  Select All on This Page
                </div>
              )}

              {/* Deselect All */}
              {showDeselectAll && (
                <div className="px-3 py-1 hover:bg-gray-100 cursor-pointer" onClick={onDeselectAll}>
                  Deselect All
                </div>
              )}

              {/* Deselect All on This Page */}
              {showDeselectPage && (
                <div className="px-3 py-1 hover:bg-gray-100 cursor-pointer" onClick={onDeselectPage}>
                  Deselect All on This Page
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default React.forwardRef(MultipleSelectRef);
